export default {
  strict: true,
  namespaced: true,
  state: {
    view: {
      list: [],
      loading: false,
    }
  },
  mutations: {
    setViewData (state, data) {
      for (let field in data) {
        state.view[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/discount-codes/view-list.js